import * as types from './types'
import { GETVatTypesResponse } from '@cbgms/api/modules/vat'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import { WorkorderLineType } from '@cbgms/api'

interface GetVatTypeFilterProps {
  lineType?: WorkorderLineType
  activityUUID?: string
  warehousePartUUID?: string
  revenueGroupUUID?: string
}

export const getVatTypes = (params?: GetVatTypeFilterProps) =>
  AsyncAction<GETVatTypesResponse>({
    type: [types.GET_VAT_TYPES, types.GET_VAT_TYPES_SUCCESS, types.GET_VAT_TYPES_FAILED],
    payload: {
      api: 'gms',
      request: {
        method: 'GET',
        url: '/modules/vat/types',
        params
      }
    }
  })
